export default "__VITE_ASSET__Be1KXsML__"